<template>
<div>
    <div v-show="display">
        <h1 :class="selected ? 'text-sm pt-2' : 'text-xl pt-0.5 font-bold'"> {{$t('form.marque.quelle_est_la_marque_du_produit')}} </h1>
        <sav-fold-card v-model="open" class="mt-4" :can-open="canOpen" :close-button="false" :id="$options.name">
            <template v-slot:close>
                <div class="font-bold" v-if="selected">
                    <div class="flex items-center">
                        <img class="h-6 mr-2" v-if="selected.img" :src="selected.img" alt="">
                        <span v-if="selected.display_libelle == '1'">{{selected.label}}</span>
                    </div>
                </div>
            </template>
            <template v-slot:open>
                <input type="text" test-id="brand-input" v-if="!hasDefaultData" class="mb-3 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-gray-400 focus:border-gray-400 block w-full p-2.5" :placeholder="$t('form.marque.rechercher_une_marque')" v-model="brand" @input="brand = $event.target.value">
                <template v-if="selected">
                    <small class="block mb-2">{{$t('form.marque.marque_selectionnee')}} :</small>
                    <div class="p-6 mb-5 bg-white bg-gray-100 border border-gray-300 rounded border-1 my-rounded">
                        <div class="flex items-center">
                            <i class="mr-4 text-xl text-green-600 fas fa-check-circle"></i>
                            <img v-if="selected.img" style="height: 40px" class="mr-2" v-lazy="imgSource(selected)">
                            <h5 v-if="selected.display_libelle == '1'" class="mb-0 capitalize">{{ selected.label || '-' }}</h5>
                        </div>
                    </div>
                </template>
                <div class="mb-3 -mt-1 text-sm font-light text-orange-500" v-if="!hasDefaultData && brand && brand.length < 2">{{$t('form.marque.saisissez_au_moins_deux_caracteres')}}</div>
                <sav-spinner class="mb-3" v-if="loading" :size="10" />
                <template v-if="data">
                    <small v-if="selected" class="block mb-2">{{$t('form.marque.nouvelles_marques')}} :</small>
                    <div v-for="(item, index) in data" :key="item.id" :test-id="'result-' + index" class="relative flex flex-col min-w-0 mb-3 break-words duration-200 bg-white border border-gray-300 rounded cursor-pointer border-1 hover:border-gray-350 hover:bg-gray-50 hover:shadow my-rounded" @click="end(item)">
                        <div class="flex items-center p-6 no-gutters">
                            <div class="mr-2">
                                <img style="height: 40px" v-lazy="imgSource(item)">
                            </div>
                            <h5 v-if="item.display_libelle == '1'" class="mb-0 capitalize">{{ item.label || '-' }}</h5>
                        </div>
                    </div>
                    <div class="relative flex flex-col min-w-0 px-5 py-4 mb-3 font-light text-gray-400 break-words bg-white border border-gray-300 rounded border-1 my-rounded" v-if="data.length <= 0"> {{$t('form.marque.aucun_resultat')}}
                    </div>
                </template>
                <!-- Modal request -->
                <modal :name="'request-' + requestModalParams.libelle">
                    <sav-request-modal :displayName="requestModalParams.label" :libelle="requestModalParams.libelle" @close="hideRequestModal" />
                </modal>
                <button @click="displayRequestModal" class="block ml-auto mt-4 text-gray-900 font-light border border-gray-200 p-1.5 px-3 text-xs rounded-xl hover:bg-gray-100 duration-200">
                    <i class="fa-solid fa-circle-question mr-0.5"></i> {{requestModalParams.label}} {{$t('form.marque.introuvable')}}
                </button>
            </template>
        </sav-fold-card>
    </div>
    <div v-if="!display">
        <sav-spinner />
    </div>
</div>
</template>

<script>
import apiService from '@/services/api.service'
import FormCardExtension from '@/extends/FormCardExtension'

export default {
    name: 'brand',
    extends: FormCardExtension,

    watch: {
        brand: function(value) {
            this.findBrand()
        }
    },

    data() {
        return {
            brand: null,
            timerSearch: null,
            hasDefaultData: false,
            display: false
        }
    },

    methods: {
        async init() {
            this.loading = true

            // Check if data
            if (this.$formTool.getFormData(this.$options.name)) {
                this.nextBlock = this.$formTool.blockData(this.$options.name).next
                this.selected = JSON.parse(JSON.stringify(this.$formTool.getFormData(this.$options.name)))
            }

            // Check can open card after set-case
            this.removeOpenAfterSetCase()

            // Set Modal Requests
            this.requestModalParams = {
                label: this.$t('form.marque.marque'),
                libelle: 'marque'
            }

            // Get default brands
            await this.getBrandData(null)

            this.display = true

            this.loading = false
        },

        end(callbackData) {
            this.brand = null
            if (!this.hasDefaultData) {
                this.data = null
            }
            this.$formTool.addFormData(this.$options.name, callbackData)
            this.nextBlock = this.$formTool.blockData(this.$options.name).next
            if (this.selected) {
                this.$emit('update', this.$options.name)
            }
            this.selected = JSON.parse(JSON.stringify(callbackData))
        },

        async getBrandData(marque) {
            let response = await apiService.post('getbrand', {
                marque: marque
            })
            if (response.data.posts.post && response.data.posts.post.length > 0) {
                this.data = this.$imgGridTool.convert('marque', 'img', [...response.data.posts.post])
            } else {
                this.data = null
            }
            if (!marque && this.data) {
                this.hasDefaultData = true
            }
        },

        async findBrand() {
            // Get api data
            if (this.brand && this.brand.length < 2) {
                if (!this.hasDefaultData) {
                    this.data = null
                    await this.getBrandData(null)
                }
                return
            }
            this.loading = true
            window.clearTimeout(this.timerSearch)
            this.timerSearch = setTimeout(async () => {
                await this.getBrandData(this.brand)
                this.loading = false
            }, 500)
        },

        imgSource(item) {
            return item.img ? item.img : 'https://disticloudfiles.net/img/savinfo/default/img-broken.png'
        }
    },

    mounted() {
        this.init()
    }
}
</script>



// WEBPACK FOOTER //
// src/processes/cards/product/BrandCard.vue